import { Tag } from "../types/freight/tag.type";

export const sortShipmentTags = (shipmentTags: Tag[]): Tag[] =>
  shipmentTags.length > 1
    ? [...shipmentTags].sort((a: Tag, b: Tag) =>
        a.position && b.position ? Number(a.position) - Number(b.position) : 1
      )
    : shipmentTags;
